module.exports = __webpack_public_path__ + "img/GavialStone.d1a60412.png";